import {useState} from 'react'
import {useTranslation} from 'react-i18next'
import {Button} from '@/components/ui/button'
import {ListEmptyState, SectionCard} from '@/components/section-card'
import {ReporteControl} from '@/components/bateria/reporte-control'
import {ResultadosSection} from '@/components/bateria/resultados-section'
import {HelpIcon} from '@/components/help-icon'
import {useStartReporte, type BateriaEvaluacion} from '@/hooks/bateria/use-bateria'
import {translateApiError} from '@/lib/errors'

export function ResultadosTab({
  businessId,
  evaluacionId,
  evaluacion,
  hasValidated,
  totalPaquetes,
}: {
  businessId: string
  evaluacionId: string
  evaluacion: BateriaEvaluacion
  hasValidated: boolean
  totalPaquetes: number
}) {
  const {t} = useTranslation()
  const regenerar = useStartReporte(businessId, evaluacionId)
  const [error, setError] = useState<string | null>(null)

  if (!hasValidated) {
    return (
      <div className="surface" data-testid="resultados-tab-empty">
        <ListEmptyState page title={t('admin.bateria.resultados.emptyTitle')} />
      </div>
    )
  }

  return (
    <>
      <SectionCard
        title={
          <span className="inline-flex items-center gap-1.5">
            {t('admin.bateria.reporte.title')}
            <HelpIcon
              label={t('common.help.iconLabelFor', {campo: t('admin.bateria.reporte.title')})}
              testId="reporte-tip">
              {t('admin.bateria.reporte.tip')}
            </HelpIcon>
          </span>
        }
        actions={<ReporteControl businessId={businessId} evaluacionId={evaluacionId} evaluacion={evaluacion} />}
        bodyClassName="space-y-3 px-5 py-3.5">
        {evaluacion.reporte_status != null && evaluacion.reporte_desactualizado && (
          <div className="tone-amber flex flex-wrap items-center justify-between gap-2 rounded-md px-3 py-2 text-xs">
            <span data-testid="banda-informe-desactualizado">
              {t('admin.bateria.bandaDeVerdad.informeDesactualizado')}
            </span>
            <Button
              size="xs"
              variant="outline"
              data-testid="banda-regenerar-informe"
              disabled={regenerar.isPending}
              onClick={() => {
                setError(null)
                regenerar.mutate(undefined, {onError: (err) => setError(translateApiError(err))})
              }}>
              {t('admin.bateria.reporte.regenerate')}
            </Button>
          </div>
        )}
        {error && <p className="text-xs text-destructive">{error}</p>}
      </SectionCard>
      <ResultadosSection
        businessId={businessId}
        evaluacionId={evaluacionId}
        enabled={hasValidated}
        totalPaquetes={totalPaquetes}
      />
    </>
  )
}
